import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next';
import { useStore } from '../../store/store';
import { iconButtonStyle } from '../../utils/styles';
import { NavbarButton } from '../Layout/NavbarButton';
import AdderMenuDisposition from './AdderMenuDisposition';
import DuotoneLightIcon from '../common/DuotoneLightIcon';

const selector = (id) => ({
  containers,
  currentProposal
}) => {
  const container = containers.find((c) => c.id === id);
  return {
    currentProposal,
    container: container,
    containerColumnsLength: container.columnsIds.length
  }
};

const RearangeColumnsButton = ({ id, menuIsOpen, setMenuIsOpen }) => {
  const {
    containerColumnsLength,
    currentProposal,
    container
  } = useStore(selector(id));
  const { t } = useTranslation();
  // Identité stable : c'est la clé sur laquelle l'arbitre du menu unique
  // reconnaît le menu courant (useSingleOpenFloatingMenu).
  const closeMenu = useCallback(() => setMenuIsOpen(false), [setMenuIsOpen]);

  if (containerColumnsLength === 1 || containerColumnsLength === 4) return null;
  const disableRearange = currentProposal.id !== null && container?.editable === false

  return (
    <div style={{
      position: "relative",
      display: "flex",
      justifyContent: "center",
    }}>
      <NavbarButton
        tooltipContent={t('container-layoutTooltip')}
        onClick={() => setMenuIsOpen(true)}
        disabled={disableRearange}
        icon={<DuotoneLightIcon name='pen-to-square' style={iconButtonStyle()} />}
      />
      {menuIsOpen && <AdderMenuDisposition
        containerId={id}
        closeMenu={closeMenu}
        columnIndex={null}
      />}
    </div>)
}

export default RearangeColumnsButton
